import { Component, OnInit, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'ServiceError',
  standalone: false,
  templateUrl: './service-error.component.html',
  styleUrls: ['./service-error.component.scss']
})
export class ServiceErrorComponent implements OnInit {
  @Input() errorCode: HttpErrorResponse;
  statusText: string;

  background: string;

  backgrounds: string[] = [
    'forest.jpg','servers.jpg', 'road.jpg'
  ];

  effects: string[] = [
    'fire.jpg', 'lightning.jpg', 'lava.jpg'
  ];

  foreground: string;

  constructor()
  {
    this.GenerateErrorBackgroundLooks();
  }

  ngOnInit() {
    if (this.errorCode.status == 0) {
      this.statusText = 'OOPS';
    } else {
      this.statusText = this.errorCode.status.toString();
    }
  }

  GenerateErrorBackgroundLooks() {
    const backgroundIndex = Math.floor((Math.random() * this.backgrounds.length));
    const effectIndex = Math.floor((Math.random() * this.effects.length));
    this.background = '../../../assets/error/scenes/' + this.backgrounds[backgroundIndex];
    this.foreground = '../../../assets/error/effects/' + this.effects[effectIndex];
  }

}

